import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { stylesCreatedForMeQueryOptions } from '../../../-hooks/useStylesCreatedForMeQuery';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(list)/styles-created-for-me/',
)({
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    ...(search.sort !== undefined ? { sort: search.sort } : {}),
    ...(search.filters !== undefined ? { filters: search.filters } : {}),
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(stylesCreatedForMeQueryOptions(deps)),
  component: lazyRouteComponent(
    () => import('../../../-components/StylesCreatedForMeTab'),
    'StylesCreatedForMeTab',
  ),
});
